import { I, P, Span, Button, Div, onShowElement } from 'alkali'

/**
 * @name ConfirmationPopover
 * @description
 * Higher-order-component that decorates a clickable element
 * (button, link, etc.) with a confirmation popover.
 *
 * If specifying a container, it is recommended to use the nearest
 * possible ancestor (rather than body).
 *
 * @example
 * ```js
 * new ConfirmationPopover(new Button(), () => {
 *	 console.log('do stuff on confirm')
 * }, {
 *	 container: parent.element
 * })
 * ```
 */

class ConfirmationPopover {
	/**
	 * @param {AlkaliElement} button - Clickable element (a, button, etc)
	 * @param {Function} callback
	 * @param {Object} options - Passed to Bootstrap Popover
	 */

	constructor(button, callback, options = {}) {
		this.button = $(button)
		this.callback = callback
		this.isOpen = false

		this.content = new Div('.confirmation-popover')

		if (options.text) {
			this.content.append(P('.text-left', { content: options.text }))
		}

		let yesBtn
		if (options.controls != false) {
			this.content.append(
				Div('.btn-group', [
					(yesBtn = new Button(
						'.btn.btn-default.btn-sm',
						{
							onclick: () => {
								this.hide()
								this.callback()
							},
						},
						[
							I('.fa.fa-check.text-success'),
							Span('.text-success', { textContent: options.yesText || ' Yes' }),
						]
					)),
					Button(
						'.btn.btn-default.btn-sm',
						{
							onclick: () => this.hide(),
						},
						[
							I('.fa.fa-remove.text-danger'),
							Span('.text-danger', { textContent: options.noText || ' No' }),
						]
					),
				])
			)
		}
		if (!this.button.popover)
			return console.log('no popover')
		this.button.popover(
			Object.assign(
				{
					content: this.content,
					html: true,
					trigger: 'manual',
					title: 'Are you sure?',
				},
				options
			)
		)

		if (options.auto != false)
			this.button.on('click', e => {
				e.stopPropagation()
				e.preventDefault()
				this.toggle()
			})
		this.button.on('shown.bs.popover', () => {
			onShowElement(this.content)
			yesBtn && yesBtn.focus()
		})

		$(document).on('click', event => {
			const isOutsidePopover = $(event.target).closest('.popover').length === 0
			if (this.isOpen && isOutsidePopover) {
				this.hide()
			}
		})
	}

	toggle() {
		if (this.isOpen) {
			this.hide()
		} else {
			this.show()
		}
	}

	show() {
		this.isOpen = true
		this.button.popover('show')
	}

	hide() {
		this.isOpen = false
		this.button.popover('hide')
	}
}

export default ConfirmationPopover
